export default "__VITE_ASSET__CNKYr2dx__"